import { supabase } from './supabaseClient';

export type AuditAction     = 'created' | 'updated' | 'deleted' | 'viewed' | 'archived' | 'restored'
                             | 'superadmin_impersonation_start' | 'superadmin_impersonation_end';
export type AuditEntityType = 'product' | 'warehouse' | 'zone' | 'user' | 'invitation' | 'company' | 'job_position'
                             | 'sso_document' | 'work_permit' | 'work_permit_template'
                             | 'checklist_item'   // "No aplica" manual del Checklist (bloque 6, C7)
                             | 'emergency_plan'   // borrado del Plan de Emergencias v2 (PE-A3c)
                             | 'emergency_drill' | 'emergency_drill_annual_report' // simulacros (PE-B2)
                             | 'company_site'     // sedes (F1a, M40)
                             | 'worker'           // trabajadores (F1a2): solo nombre, puesto y sede
                             | 'inspection'       // inspecciones del motor nuevo: firma y reapertura (F3a, M41)
                             | 'signed_record';   // registros firmados por el trabajador: asistencia, EPP y aptitud (M45)

export interface AuditPayload {
  company_id:  string;
  action:      AuditAction;
  entity_type: AuditEntityType;
  entity_id:   string;
  entity_name: string;
  details?:    Record<string, unknown>;
}

export function logAudit(payload: AuditPayload): void {
  (async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data: prof } = await supabase
        .from('profiles')
        .select('full_name, email')
        .eq('id', user.id)
        .maybeSingle();
      await supabase.from('audit_logs').insert({
        ...payload,
        user_id:   user.id,
        user_name: (prof as { full_name?: string | null; email?: string | null } | null)?.full_name
                   ?? (prof as { full_name?: string | null; email?: string | null } | null)?.email
                   ?? user.email
                   ?? 'Desconocido',
      });
    } catch {
      // audit must not break the main flow
    }
  })();
}

export function logAuthEvent(action: string, details?: Record<string, unknown>): void {
  (async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data: prof } = await supabase
        .from('profiles')
        .select('full_name, email, company_id')
        .eq('id', user.id)
        .maybeSingle();
      const profData = prof as { full_name?: string | null; email?: string | null; company_id?: string | null } | null;
      await supabase.from('audit_logs').insert({
        company_id:  profData?.company_id ?? null,
        action,
        entity_type: 'auth',
        entity_id:   user.id,
        entity_name: profData?.full_name ?? profData?.email ?? user.email ?? 'Desconocido',
        user_id:     user.id,
        user_name:   profData?.full_name ?? profData?.email ?? user.email ?? 'Desconocido',
        details:     details ?? null,
      });
    } catch {
      // audit must not break the main flow
    }
  })();
}
